/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import { Page } from "components/core/Page";
import Container from "components/core/Page/Container";
import { H2, H3 } from "components/core/Typography";
import { ScrollToTop } from "components/core/ScrollToTop";
import { StorageHeader } from "components/storages/Header";
import { SIZE_GUIDE_DATA } from "components/storages/ContentData/SizeGuideData";
import {
	Description,
	LastSearchBar,
	BorderLine,
	SizeGuideCards
} from "components/storages/Common";
import "../StoragePages.scss";
import { useSelector } from "react-redux";
import { PAGE_SUB_TYPES } from "@sparefoot/tracking-events";
import usePageViewTracking from "hooks/tracking/usePageViewTracking";

const CombinedSection = ({ title, desc }) => (
	<>
		<H3>{title}</H3>
		<Description desc={desc} />
	</>
);

const SizeGuidePage = () => {
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	usePageViewTracking(PAGE_SUB_TYPES.SIZE_LANDING);

	return (
		<Page
			className="storage-page"
			pageType={PAGE_SUB_TYPES.SIZE_LANDING}
			title="How to Choose the Right Size Storage Unit For Your Needs | Storage.com"
			description="How to Choose the Right Size Storage Unit For Your Needs | Storage.com"
			canonical={`${baseUrl}/self-storage-size-guide/`}
		>
			<Container>
				<StorageHeader
					heading="Find Storage Units Near You!"
					level="1"
				/>
				<div className="all-sections">
					{SIZE_GUIDE_DATA.map((item, index) => (
						<>
							<H2 size="xxlarge">{item.mediumHeading}</H2>
							<br />
							<Description desc={item.description} />
							{item.subHeadings?.map((subHeading) => (
								<>
									{subHeading.customCardsData ? (
										<SizeGuideCards />
									) : (
										<CombinedSection {...subHeading} />
									)}
								</>
							))}
							{item.points && (
								<ul>
									{item.points?.map((point) => (
										<>
											<li>
												{point.desc}
												<br />
											</li>
										</>
									))}
								</ul>
							)}

							{item.description2 && (
								<Description desc={item.description2} />
							)}
							{index !== SIZE_GUIDE_DATA.length - 1 && (
								<BorderLine />
							)}
						</>
					))}
					<LastSearchBar />
				</div>
			</Container>
			<ScrollToTop />
		</Page>
	);
};

CombinedSection.propTypes = {
	title: PropTypes.string,
	desc: PropTypes.string
};

export default SizeGuidePage;
